import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdOutlineAttachMoney } from "react-icons/md";
import { MdAttachMoney } from "react-icons/md";

import './layout.css';

const AccountLayout = ({ children }) => {

  
 
  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <MdAttachMoney  className="leave-policy-icon" />
        All Accounts
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="accounts-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/accounts"
              >
                <MdOutlineAttachMoney className="nav-icon" />Account
              </NavLink>
            </li>
           
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default AccountLayout;
